
import { useEffect, useState } from "react";
import { IconButton, useColorModeValue } from "@chakra-ui/react";
import { ChevronUpIcon } from "@chakra-ui/icons";
export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);
  const mainColor = "#000";
  const accentColor = "#f2be44"; 

  const bgColor = useColorModeValue("white", "gray.700");


  const toggleVisibility = () => {
    setIsVisible(window.scrollY > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  if (!isVisible) return null;

  return (
    <IconButton
      position="fixed"
      bottom={{ base: "20px", md: "40px" }}
      right={{ base: "20px", md: "40px" }}
      size="lg"
      icon={<ChevronUpIcon />}
      onClick={scrollToTop}
      colorScheme="orange"
      bg={bgColor}
      color={mainColor}
      boxShadow="md"
      zIndex={100}
      _hover={{ bg: accentColor, color: "white" }}
      aria-label="Scroll to top"
    />
  );
}
